import React, { Fragment } from "react"
import PropTypes from "prop-types"
import ObserveProps from "@geome/react-next/lib/util/observeProps"
import PointRenderer from "@geome/react-components/lib/components/map/renderer/point"
import ClusterRenderer from "@geome/react-components/lib/components/map/renderer/cluster"
import Cluster from "@geome/react-components/lib/components/cluster"
import Marker from "@geome/shell-locator-components/lib/components/marker"

class Locations extends React.Component {
  static propTypes = {
    locations: PropTypes.array.isRequired,
    onOverlayRequest: PropTypes.func.isRequired,
    highlighted: PropTypes.object,
    selected: PropTypes.object,
  }

  shouldComponentUpdate(nextProps) {
    return ObserveProps(this.props, nextProps, ["highlighted", "locations"])
  }

  render() {
    const { locations, highlighted, selected, onOverlayRequest } = this.props
    return (
      <Fragment>
        <PointRenderer
          subjects={locations}
          highlighted={highlighted}
          selected={selected}
          childComponent={Marker}
          overlay={onOverlayRequest("locations-points")}
          offset={{ bottom: 21, left: 20 }}
        />
        <ClusterRenderer
          subjects={locations}
          childComponent={Cluster}
          overlay={onOverlayRequest("locations-clusters")}
        />
      </Fragment>
    )
  }
}

export default Locations
